import { ModalCustom } from "components/ModalCustom";
import { FaCheck } from "react-icons/fa";
import { Icone, ModalBody } from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
}

export function ModalSucessoAprovarLote({ show, handleClose }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Aprovar lote"
      centered
    >
      <ModalBody>
        <Icone>
          <FaCheck />
        </Icone>
        Lote aprovado com sucesso!
      </ModalBody>
    </ModalCustom>
  );
}
